<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="rule-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-rule">活动规则</div>
                    <div class="rule-view">
                        <div class="text-item">
                            <div class="tag">1</div>
                            <p>活动时间：10月30日-11月12日</p>
                        </div>
                        <div class="text-item">
                            <div class="tag">2</div>
                            <p>本次活动分为自选宝库、百亿补贴和狂欢商店三个部分。</p>
                        </div>
                        <div class="text-item">
                            <div class="tag">3</div>
                            <p>自选宝库部分，仙术师们可挑选自己需要的道具打包购买，3个档位的自选宝库分别限购3/4/5次，购买任意宝库时会有一定概率掉落当前库内的随机道具（超值自选库必定掉落）。</p>
                        </div>
                        <div class="text-item">
                            <div class="tag">4</div>
                            <div class="text">在百亿补贴部分，仙术师们可直接购买道具，每种道具限购1次，三位好友助力后可领取1份双11助力包<div class="icon-box" v-tips="'JM04'"></div>和1张8折券，8折券无使用次数上限，但仅可在百亿补贴使用。同一个电魂ID仅可帮人助力3次。</div>
                        </div>
                        <div class="text-item">
                            <div class="tag">5</div>
                            <p>本次活动消耗梦三币时，会以1:1的比例转化为狂欢积分<em class="icon-score"></em>，仙术师可使用狂欢积分在狂欢商店兑换道具。</p>
                        </div>
                        <div class="text-item">
                            <div class="tag">6</div>
                            <p>所有道具购买记录及兑换记录将显示在历史记录中，玩家可自行查看。</p>
                        </div>                                                                        
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
    .dialog-view{
        z-index: 100;
    }

    .t-rule{
        margin-bottom: 20px;
    }

    .rule-view{
        // padding: 0 42px;
        font-size: 18px;
        color: #696560;

        .text-item{
            position: relative;
            padding-left: 40px;

            .tag{
                position: absolute;
                left: 0;
                top: 0;
                width: 24px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                background-color: #efe6d7;
                color: #8e6e25;
                border: 1px solid #c0b498;
                border-radius: 3px;
            }
        }

        p{
            line-height: 1.8;
            margin-bottom: 20px;
        }

        .text{
            line-height: 1.8;
            margin-bottom: 20px;
        }
    }
    
    .reward-item{
        display: inline-block;
        vertical-align: middle;
        width: 46px;
        height: 46px;
    }

    .icon-box{
        display: inline-block;
        vertical-align: middle;
        width: 26px;
        height: 24px;
        background-image: url(~@/assets/images/modal/icon-token-box.png);
        background-size: cover;
        background-repeat: no-repeat;
    }    

    .icon-bind-gift{
        display: inline-block;
        vertical-align: middle;
        width: 25px;
        height: 30px;
        background-image: url(~@/assets/images/modal/icon-bind-gift.png);
    }


    .icon-score{
        display: inline-block;
        vertical-align: middle;
        width: 30px;
        height: 28px;
        background-image: url(~@/assets/images/modal/icon-token-sm.png);
    }
  
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            rid : 1,
        }
    },  
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>